<style src="./styles.scss" lang="scss" scoped></style>
<template>
  <table class="table table-hover table-mail">
    <thead class="table-head">
      <tr>
        <th>VENCIMENTO</th>
        <th>PAGAMENTO</th>
        <th>DESCRIÇÃO</th>

        <th>SALDO ANTERIOR</th>
        <th>VALOR</th>
        <th>SALDO POSTERIOR</th>
        <th>PAGAMENTO</th>
        <th>ORIGEM</th>
        <th>DESTINO</th>
        <th>Arquivo</th>
      </tr>
    </thead>
    <tbody class="table-list">
      <tr
        v-for="(movement, key) in history"
        :key="key"
        class="item"
        :class="movement.type"
      >
        <td :class="isReceive(movement)">
          {{ movement.expiration | DateBR }}
          <span
            class="movement-indicator"
            :class="`${movement.employee.movementType}-indicator`"
            v-if="movement.employee.isEmployee"
          >
            |
            {{ movementIndicator(movement.employee.movementType) }}
          </span>
        </td>
        <td>
          {{ movement.paymentDate ? movement.paymentDate : '' | DateBR }}
        </td>
        <td>{{ movement.description }}</td>
        <td>{{ movement.beforeBalance | totalToCurrencyBR }}</td>
        <td>{{ movement.amount | totalToCurrencyBR }}</td>
        <td>{{ movement.afterBalance | totalToCurrencyBR }}</td>
        <td>{{ paymentType(movement.paymentType) }}</td>

        <td>
          {{ movement.account.name }}
        </td>
        <td>
          <p v-if="movement.transferredTo">
            {{ movement.transferredTo.name }}
          </p>
          <p v-else>N/A</p>
        </td>

        <td>
          <button
            v-if="movement.filesPath.length > 0"
            class="btn btn-outline"
            @click="showFiles(movement.filesPath)"
          >
            <i class="fa fa-file"></i>
          </button>
        </td>
        <td>
          <h4 v-if="movement.creditor">
            {{ getCreditorName(movement.creditor) }}
          </h4>
        </td>
      </tr>

      <tr />
    </tbody>
  </table>
</template>
<script>
import { URI } from '@/config/config';

const EmployeeMovementType = {
  WITHDRAW: 'withdraw',
  REINFORCEMENT: 'reinforcement',
  CLOSE: 'close',
  DIFFERENCE: 'difference',
};
const PersonType = {
  PHYSICAL: 'physical',
  LEGAL: 'legal',
};
export default {
  props: {
    history: {
      default: Array,
    },
    account: {
      type: String,
      default: '',
    },
  },

  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      if (!dt) return 'Sem data';
      return new Date(dt).toLocaleString('pt-br');
    },
  },

  methods: {
    paymentType(type) {
      switch (type) {
        case 'cash': {
          return 'Dinheiro';
        }
        case 'credit': {
          return 'Crédito';
        }
        default:
          return 'Débito';
      }
    },
    movementIndicator(employeeMovement) {
      switch (employeeMovement) {
        case EmployeeMovementType.WITHDRAW:
          return 'Retirada';
        case EmployeeMovementType.REINFORCEMENT:
          return 'Reforço';
        case EmployeeMovementType.CLOSE:
          return 'Fechamento';
        case EmployeeMovementType.DIFFERENCE:
          return 'Diferença';
        default:
          return '';
      }
    },
    showFiles(files) {
      files.forEach((file) => {
        const path = `${URI}notify-photos/${file}`;
        window.open(path);
      });
    },
    getCreditorName(creditor) {
      if (creditor.personType === PersonType.PHYSICAL) {
        return creditor.physical.name;
      } else if (creditor.personType === PersonType.LEGAL) {
        return creditor.legal.companyName;
      } else {
        return '';
      }
    },
    isReceive(movement) {
      if (movement.type === 'receive') {
        return 'receive-header';
      }
      if (movement.type === 'expense') {
        return 'expense-header';
      }

      if (String(movement.account._id) == String(this.account)) {
        return 'expense-header';
      }
      return 'receive-header';
    },
  },
};
</script>